import BaseService from '../BaseService';

class VisitasViasService extends BaseService {
    constructor() {
        super('/visitas/vias/');
    }
}

export default new VisitasViasService();
